import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';

import { ObservationModel } from 'src/app/models/observation.model';
import { RemedialModel } from 'src/app/models/remedial.model';
import { AssetPresetStlModel } from 'src/app/models/asset_preset_stl.model';

import { ModalObservationComponent } from '../modal-observation/modal-observation.component';
import { ModalCustomRemedialComponent } from '../modal-custom-remedial/modal-custom-remedial.component';

import { Constants } from 'src/app/constants/constants';
import { ModalReportWhereComponent } from '../modal-report-where/modal-report-where.component';
import { AssetModel } from 'src/app/models/asset.model';


@Component({
  selector: 'modal-single-observation',
  templateUrl: './modal-single-observation.component.html',
  styleUrls: ['./modal-single-observation.component.scss'],
})
export class ModalSingleObservationComponent implements OnInit {

 

  observationUid: number;
  selectedAssetDetails: AssetModel = null;
  changeMade: boolean = false;
  modalOpen: boolean = false;
 


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService,
   private alertController: AlertController) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    this.loadObservation();
  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(null, null, 'SingleObservationModal');
  }


  loadObservation()
  {
    this.selectedAssetDetails = null;

    this.appearanceService.showLoading("Please wait...").then(() => {

      var payload = {
        clientUid: this.clientService.getClientUid(),
        observationUid: this.observationUid
      };

      this.assetService.getSingleObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.selectedAssetDetails = new AssetModel();
          this.selectedAssetDetails.observations = new Array<ObservationModel>();

            var entry = response.Observation;

            var observation                               = new ObservationModel();
            observation.uid                               = Number(entry.observationUid);
            observation.assetUid                          = Number(entry.assetUid);
            observation.observationInfo                   = entry.observationInfo;
            observation.conditionCode                     = entry.conditionCode;
            observation.ref                               = entry.observationRef;
            observation.observedDateTime                  = entry.observedDateTime;
            observation.chosenRemedials                   = new Array<RemedialModel>();
            observation.customRemedials                   = new Array<RemedialModel>();
            observation.presetStlRemedialUids             = new Array<any>(); // @Fil Can be removed once updated to use model below
            observation.currentStlPresets                 = new Array<AssetPresetStlModel>(); 
            observation.loggedByUser                      = entry.loggedByUser;
            observation.repairedOnJobUid                  = entry.repairedOnJobUid;
            observation.recommendedOnJobUid               = entry.recommendedOnJobUid;
            observation.repairedByUser                    = entry.repairedByUser;
            observation.recommendedByUser                 = entry.recommendedByUser;
            observation.repairNotes                       = entry.repairNotes;
            observation.condemnAssetReuseParts            = entry.condemnAssetReuseParts;
            observation.condemnAssetReusePartsText        = entry.condemnAssetReusePartsText;
            observation.condemnAssetIsolated              = entry.condemnAssetIsolated;
            observation.condemnFuseRemoved                = entry.condemnFuseRemoved;
            observation.condemnAssetSufficientLighting    = entry.condemnAssetSufficientLighting;
            observation.condemnAssetDangerousPosition     = entry.condemnAssetDangerousPosition;
            observation.condemnAssetDangerousPositionText = entry.condemnAssetDangerousPositionText;
            observation.observedDateTimeReadable          = entry.observedDateTimeReadable;
            observation.recommendedDateTimeReadable       = entry.recommendedDateTimeReadable;
            observation.repairedDateTimeReadable          = entry.repairedDateTimeReadable;
            observation.recommendedJobInfo                = entry.recommendedJobInfo;
            observation.repairedJobInfo                   = entry.repairedJobInfo;

            observation.repairedDateTime      = null;
            observation.recommendedDateTime   = null;
            observation.powerIssue            = null;

            if (entry.powerIssue)
            {
              observation.powerIssue = entry.powerIssue;
            }

            if (entry.repairedDateTime) 
            {
              observation.repairedDateTime = entry.repairedDateTime;
            }

            if (entry.recommendedDateTime) 
            {
              observation.recommendedDateTime = entry.recommendedDateTime;
            }

            for (var y = 0; y < entry.remedials.length; y++)
            {
              var newRemedial = new RemedialModel();

              newRemedial.assetObservationRemedialUid   = Number(entry.remedials[y].assetObservationRemedialUid);
              newRemedial.stlCode                       = entry.remedials[y].stlCode;
              newRemedial.quantity                      = Number(entry.remedials[y].stlQuantity);
              newRemedial.name                          = entry.remedials[y].remedialName;
              newRemedial.remedialUid                   = Number(entry.remedials[y].remedialUid);

              observation.chosenRemedials.push(newRemedial)
            }   

            for (var z = 0; z < entry.customRemedials.length; z++)
            {
              var newCustomRemedial = new RemedialModel();

              newCustomRemedial.assetObservationCustomRemedialUid   = Number(entry.customRemedials[z].assetObservationCustomRemedialUid);
              newCustomRemedial.stlCode                             = entry.customRemedials[z].customRemedialCode;
              newCustomRemedial.name                                = entry.customRemedials[z].customRemedialName;
              newCustomRemedial.charge                              = entry.customRemedials[z].customRemedialCharge;

              observation.customRemedials.push(newCustomRemedial)
            }   

            for (var z = 0; z < entry.stlPresets.length; z++)
            {
              // @Fil Can be removed once updated to use model below
              observation.presetStlRemedialUids.push(entry.stlPresets[z].stlPresetUid);

              var newStlPreset  = new AssetPresetStlModel();
              newStlPreset.uid  = entry.stlPresets[z].stlPresetUid;
              newStlPreset.name = entry.stlPresets[z].stlPresetName;
              
              observation.currentStlPresets.push(newStlPreset);
            }

            this.selectedAssetDetails.observations.push(observation);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
          this.closeModal(null);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        this.closeModal(null);

      });
    });
  }


  async changeReportedUser(isRepair, obs, isRecommended)
  {
    const modal = await this.modalController.create({
      component: ModalReportWhereComponent,
      backdropDismiss: false,
      componentProps: { selectedList: [], whereCriteria: "users" , limit: 1},
      id: 'ReportWhereModal'
    });

    modal.onDidDismiss().then(async (response) => {

      if (response.data)
      {
        if (response.data.selected)
        {          
          var payload = {
            isRepair: isRepair,
            isRecommended: isRecommended,
            observationUid: obs.uid,
            newUserUid: response.data.selected[0].uid,
            newUserName: response.data.selected[0].name
          }

          this.appearanceService.showLoading("Please wait...").then(() => {

            this.assetService.changeNameOnObservation(payload).subscribe(response => {
          
              this.appearanceService.dismissLoading();
      
              if (response.Success)
              {
                if (isRepair)
                {
                  obs.repairedByUser = payload.newUserName;
                }
                else if (isRecommended)
                {
                  obs.recommendedByUser = payload.newUserName;
                }
                else
                {
                  obs.loggedByUser = payload.newUserName;
                }
              }
              else
              {
                this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
              }
            },
            err => {
      
              this.appearanceService.dismissLoading();
              this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      
            });
          });
        }
      }
    })

    return await modal.present();
  }


  async deleteObservation(assetObservationUid) 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete this observation?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmedDeleteObservation(assetObservationUid);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmedDeleteObservation(observation)
  {
    var payload = {
      observation: observation,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetName: this.selectedAssetDetails.name
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.deleteObservationFromAsset(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.appearanceService.presentToast("Observation deleted.", Constants.TOAST_SUCCESS);
          this.closeModal();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async askToDeleteObservationStl(observation, slidingRow, remedial)
  {
    var deleteAll = false;
    
    if(remedial.quantity > 1)
    {
      const alert = await this.alertController.create({
        header: 'Would you like to delete all or just one of ' + remedial.name + '?',
        buttons: [
          {
            text: 'Just One',
            role: 'confirm',
            handler: () => {
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
          {
            text: 'All',
            role: 'confirm',
            handler: (data) => {
              deleteAll = true;
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              slidingRow.close();
            },
          },
        ],
      });
  
      await alert.present();
    }
    else
    {
      const alert = await this.alertController.create({
        header: 'Are you sure you want to delete ' + remedial.name + '?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              slidingRow.close();
            },
          },
          {
            text: 'Yes',
            role: 'confirm',
            handler: (data) => {
              deleteAll = true;
              this.confirmDeleteRemedialStl(observation, slidingRow, remedial.remedialUid, deleteAll);
            },
          },
        ],
      });
  
      await alert.present();
    }

  }


  async askToDeleteObservationCustomRemedial(observation, slidingRow, remedial)
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to delete (' + remedial.stlCode + ") - " + remedial.name + '?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            slidingRow.close();
          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            this.confirmDeleteCustomRemedialStl(observation, slidingRow, remedial.assetObservationCustomRemedialUid);

          },
        },
      ],
    });

    await alert.present();
  }


  confirmDeleteCustomRemedialStl(observation, slidingRow, assetObservationCustomRemedialUid)
  {
    var payload = {
      observationUid: observation.uid,
      assetObservationCustomRemedialUid: assetObservationCustomRemedialUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeCustomRemedialStlFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();
        slidingRow.close();

        if (response.Success)
        {
          this.changeMade = true;

          observation.customRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.ObservationCustomRemedials.length; i++)
          {
            var newCustomRemedial = new RemedialModel();

            newCustomRemedial.assetObservationCustomRemedialUid   = Number(response.ObservationCustomRemedials[i].assetObservationCustomRemedialUid);
            newCustomRemedial.stlCode                             = response.ObservationCustomRemedials[i].customRemedialCode;
            newCustomRemedial.name                                = response.ObservationCustomRemedials[i].customRemedialName;
            newCustomRemedial.charge                              = response.ObservationCustomRemedials[i].customRemedialCharge;

            observation.customRemedials.push(newCustomRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        slidingRow.close();
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  confirmDeleteRemedialStl(observation, slidingRow, remedialUid, deleteAll)
  {
    var payload = {
      observationUid: observation.uid,
      remedialUid: remedialUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid,
      deleteAll: deleteAll
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRemedialStlFromObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();
        slidingRow.close();

        if (response.Success)
        {
          this.changeMade = true;

          observation.chosenRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.Observations.length; i++)
          {
            var newRemedial = new RemedialModel();

            newRemedial.assetObservationRemedialUid   = Number(response.Observations[i].assetObservationRemedialUid);
            newRemedial.quantity                      = Number(response.Observations[i].stlQuantity);
            newRemedial.stlCode                       = response.Observations[i].stlCode;
            newRemedial.name                          = response.Observations[i].remedialName;
            newRemedial.remedialUid                   = Number(response.Observations[i].remedialUid);

            observation.chosenRemedials.push(newRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        slidingRow.close();
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async addCustomRemedial(observation)
  {
    this.modalOpen = true;

    const modal = await this.modalController.create({
      component: ModalCustomRemedialComponent,
      backdropDismiss: false,
      componentProps: {  },
      id: 'CustomRemedialModal'
    });

    modal.onDidDismiss().then((response) => {

      this.modalOpen = false;
      
      if (response.data)
      {
        if (response.data.customRemedial)
        {
          this.confirmAddCustomRemedial(observation, response.data.customRemedial);
        }
      }
    })

    return await modal.present();
  }


  confirmAddCustomRemedial(observation, customRemedial)
  {
    var payload = {
      observation: observation,
      newCustomRemedial: customRemedial,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetUid: this.selectedAssetDetails.uid,
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addCustomRemedialStlToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;

          observation.customRemedials = new Array<RemedialModel>();

          for (var i = 0; i < response.ObservationCustomRemedials.length; i++)
          {
            var newCustomRemedial = new RemedialModel();

            newCustomRemedial.assetObservationCustomRemedialUid = Number(response.ObservationCustomRemedials[i].assetObservationCustomRemedialUid);
            newCustomRemedial.stlCode                           = response.ObservationCustomRemedials[i].customRemedialCode;
            newCustomRemedial.name                              = response.ObservationCustomRemedials[i].customRemedialName;
            newCustomRemedial.charge                            = response.ObservationCustomRemedials[i].customRemedialCharge;

            observation.customRemedials.push(newCustomRemedial)
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async deletePowerAlert(observation) 
  {
    const alert = await this.alertController.create({
      header: 'Are you sure you want to remove this power alert?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Yes',
          role: 'confirm',
          handler: (data) => {
            
            var payload = {
              observationUid: observation.uid,
              clientUid: this.clientService.getClientUid(),
              organisationUid: this.clientService.getOrganisationUid()
            }

            this.appearanceService.showLoading("Please wait...").then(() => {

              this.assetService.removePowerIssueFromObservation(payload).subscribe(response => {
            
                this.appearanceService.dismissLoading();
        
                if (response.Success)
                {
                  observation.powerIssue = false;
                }
                else
                {
                  this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
                }
              },
              err => {
        
                this.appearanceService.dismissLoading();
                this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        
              });
            });
          },
        },
      ]
    });

    await alert.present();
  }


  async editObservationModal(observation)
  {
    const modal = await this.modalController.create({
      component: ModalObservationComponent,
      backdropDismiss: false,
      componentProps: { 
        createNewObservation: false, 
        isEditing: true, 
        originalObservation: observation,
        selectedAsset: this.selectedAssetDetails
      },
      cssClass: 'full-screen-modal',
      id: 'RemedialModal'
    });

    modal.onDidDismiss().then((response) => {
      if (response)
      {
        if (response.data)
        {
          if (response.data.updateObservation)
          {
            var payload = {
              assetUid: observation.assetUid,
              observationUid: observation.uid,
              observationInfo: response.data.updatedInfo,
              updatedConditionCode: response.data.updatedConditionCode,
              newStls: response.data.newStls,
              changedStls: response.data.changedStls,
              clientUid: this.clientService.getClientUid(),
              organisationUid: this.clientService.getOrganisationUid(),
              newStlPresetUids: response.data.newStlPresetUids,
              deletedStlPresetUids: response.data.deletedStlPresetUids,
              condemnData: null
            };

            this.confirmObservationEdit(payload);
          }
        }
      }
    })

    return await modal.present();
  }


  confirmObservationEdit(payload)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.updateObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          this.loadObservation();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  markObservationRecommended(obs)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid,
      jobUid: 1
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addRecommendationToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          obs.recommendedOnJobUid  = 1;
          obs.recommendedByUser    = this.userService.getUserName();
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  markObservationNotRecommended(obs)
  {
    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      observationUid: obs.uid
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.removeRecommendationToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          obs.recommendedDateTime = null;
          obs.recommendedOnJobUid = null;
          obs.recommndedByUser = null;
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  async addPowerIssueToObservation(observation)
  {
    const alert = await this.alertController.create({
      header: 'Who is responsible for this power issue?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: 'Save',
          role: 'confirm',
          handler: (data) => {
            
            if (data == null)
            {
              this.appearanceService.presentToast("Please make a selection", Constants.TOAST_INFO);
              this.addPowerIssueToObservation(observation);
            }
            else
            {
              this.confirmedAddPowerIssueToObservation(data, observation);
            }
          },
        },
      ],
      inputs: [
        {
          label: 'Private',
          type: 'radio',
          value: '1',
        },
        {
          label: 'D.N.O.',
          type: 'radio',
          value: '2',
        },
      ],
    });

    await alert.present();
  }


  confirmedAddPowerIssueToObservation(choice, observation)
  {
    var payload = {
      observationUid: observation.uid,
      powerIssue: choice,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.addPowerIssueToObservation(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.changeMade = true;
          observation.powerIssue = choice;
          this.appearanceService.triggerEvent('badgeCounters:update', { });    
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  getObservationClass(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'condemned-card';
    }
    else if (observation.repairedOnJobUid)
    {
      return 'repaired-card';
    }
    else if (observation.recommendedOnJobUid)
    {
      return 'recommended-card';
    }

    return 'obs-card';
  }


  getObservationCardTitle(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'Condemned';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "Recommended";
    }
    else if (observation.repairedOnJobUid)
    {
      return "Repaired";
    }

    return observation.conditionCode;
  }


  getObservationCardTitleColor(observation: ObservationModel)
  {
    if (observation.condemnAssetReuseParts)
    {
      return 'danger';
    }
    else if (observation.recommendedOnJobUid && !observation.repairedOnJobUid)
    {
      return "warning";
    }
    else if (observation.repairedOnJobUid)
    {
      return "success";
    }

    return ""
  }


  canWeRecommenedObservation(observation: ObservationModel)
  {
    if (observation.recommendedOnJobUid || observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    return true;
  }


  canWeUnrecommenedObservation(observation: ObservationModel)
  {
    if (observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    if (observation.recommendedOnJobUid)
    {
      return true;
    }

    return false;
  }


  canWeRepairObservation(observation: ObservationModel)
  {
    if (observation.repairedOnJobUid || observation.condemnAssetReuseParts)
    {
      return false;
    }

    return true;
  }
}